// Packages
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Other
import './styles.css';

const BTDTextField = ({ autocomplete, className, description, endIcon, error, label, onChange, placeholder, required, startIcon, style, type, value, width }) => {

    const [active, setActive] = useState(false);

    useEffect(() => {

        if( value != null && value != '' ) {

            setActive(true);
        }
        else {

            setActive(false)
        }
    }, [value])


    return(
        <div>
        {description &&
            <p className='BTDTextField__description detail' dangerouslySetInnerHTML={{__html: description}}></p>
        }
        <div className={className !== '' ? className : `BTDTextField ${width} `} style={style}>
            <label className={className !== '' ? (className + '__label') : `BTDTextField__label ${active ? 'active' : ''} ${startIcon ? 'startIcon' : ''}`}>
                <span className='BTDTextField__label__wrapper'>
                    {label ?? ''}
                    {required &&
                        <span className='red'>{<>&nbsp;</>}*</span>
                    }
                </span>

            </label>
            
            {startIcon &&
                <div className="BTDTextField__startIcon">
                    {startIcon}
                </div>
            }

            <input 
                autoComplete={autocomplete ? '' : 'new-password'}
                className={className !== '' ? (className + '__input') : `BTDTextField__input ${error ?? ''} ${startIcon ? 'startIcon' : ''}`} 
                onChange={(e) => {onChange(e.target.value)}} 
                placeholder={placeholder}
                required={required} 
                type={type ?? 'text'}
                value={value} 
            />
            {endIcon &&
                <div className='BTDTextField__endIcon'/>
            }
        </div>
            {error &&
                <p className='BTDTextField__error'>{error}</p>
            }
    </div>
    )
}

BTDTextField.propTypes = {
    autocomplete: PropTypes.bool,
    className: PropTypes.string,
    description: PropTypes.string,
    endIcon: PropTypes.object,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    label: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    startIcon: PropTypes.object,
    style: PropTypes.object,
    type: PropTypes.string,
    value: PropTypes.string,
    width: PropTypes.string
}

BTDTextField.defaultProps = {
    autoComplete: false,
    className: '',
    description: null,
    endIcon: null,
    error: null,
    label: '',
    onChange: () => {alert('onChange is not set!')},
    required: false,
    startIcon: null,
    style: {},
    type: 'text',
    value: '',
    width: 'large'
}

export default BTDTextField;                                         